export default __webpack_public_path__ + "05f79e3b6ab2c77545440585f8de77b1.png";